import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class EntityService<T> {

  private _cache: { [k: string]: any } = {};

  private entity: T = {} as T;

  public entityChange = new Subject<T>();

  constructor() {
    this.initializeCache();
  }

  initializeCache(): void {
    var cache = this.getCache();
    if (!cache) {
      // Not initialized yet
      localStorage.setItem("redeployment_entity_cache", JSON.stringify(this._cache));
    }
  }

  private getCache(): { [k: string]: any } | null {
    var cache: { [k: string]: any } = {};
    var json = localStorage.getItem("redeployment_entity_cache");
    if (json) {
      cache = JSON.parse(json.toString());
    }

    return cache;
  }

  set(key: string, e: T): void {
    var cache = this.getCache();
    if (cache) {
      cache[key] = e;
      localStorage.setItem("redeployment_entity_cache", JSON.stringify(cache));
    }
  }

  get(key: string): T | null {
    var cache = this.getCache();
    if (cache) {
      return cache[key];
    }

    return null;
  }

  // Optional
  getKey(apiController: string, id: string): string {
    return apiController + "_" + id;
  }

  remove(key: string): void {
    var cache = this.getCache();
    if (cache) {
      delete cache[key];
      localStorage.setItem("redeployment_entity_cache", JSON.stringify(cache));
    }
  }

  empty(): void {
    localStorage.setItem("redeployment_entity_cache", JSON.stringify(null));
  }

  trigger(): void {
    if (this.entity != undefined && this.entity != null) {
      this.entityChange.next(this.entity);
    }
  }

}
